/**
 * Cache Constants
 *
 * Cache name constants documenting the caches the service worker
 * (vite.config.ts) creates, plus the legacy API cache it no longer creates.
 *
 * NOTE: If you change the service-worker cache values, also update
 * vite.config.ts workbox.runtimeCaching configuration to match.
 */

/**
 * Cache name for OpenStreetMap tiles.
 * Used by the service worker (CacheFirst strategy) for OSM tiles browsed
 * online. Bulk pre-seeding was removed in 1b-1 (OSM tile policy).
 */
export const MAP_TILES_CACHE_NAME = 'map-tiles';

/**
 * Legacy cache name for API responses, no longer populated by the service
 * worker. Deleted at boot (main.tsx) to retire it.
 */
export const API_CACHE_NAME = 'api-cache';

/**
 * Cache name for PDF documents.
 */
export const PDF_CACHE_NAME = 'pdf-cache';

/**
 * Cache name for images.
 */
export const IMAGE_CACHE_NAME = 'image-cache';
